import { CreateVoucherRequest, VoucherResponse } from "../../../infrastructure/model/VoucherModel";
import { VoucherService } from "../../../infrastructure/services/VoucherService";
import { FilterRequest, PageResponse } from "../../constants/AppTypes";
import HttpUtils from "../../utils/HttpUtils";
import { BaseCommonApiUseCaseDeps } from "./CommonApiUseCase";

interface GetAllVoucherUseCaseDeps extends BaseCommonApiUseCaseDeps {
  params: FilterRequest;
}

export const getAllVoucherUseCase = async (
  deps: GetAllVoucherUseCaseDeps
): Promise<PageResponse<VoucherResponse[]>> => {
  const { params, setLoading, showError } = deps;
  try {
    setLoading?.(true);
    let dataMapper: PageResponse<VoucherResponse[]> = {
      data: [],
      total: 0,
    };
    const res = await VoucherService.getAllVoucher(params.page, params.limit);
    HttpUtils.handleResponse(res, {
      onDefaultError() {
        showError?.(res?.message);
      },
      onSuccessWithData(res) {
        dataMapper = {
          data: res.data.data,
          total: res.data.total,
        };
      },
    });
    return dataMapper;
  } finally {
    setLoading?.(false);
  }
};

export const createVoucherUseCase = async (
  deps: BaseCommonApiUseCaseDeps & { request: CreateVoucherRequest }
): Promise<VoucherResponse[]> => {
  const { request, setLoading, showError, showSuccess } = deps;
  try {
    setLoading?.(true);
    let dataMapper: VoucherResponse[] = [];
    const res = await VoucherService.createVoucher(request);
    HttpUtils.handleResponse(res, {
      onDefaultError() {
        showError?.(res?.message);
      },
      onSuccessWithData(res) {
        showSuccess?.("Tạo voucher thành công");
        dataMapper = res.data;
      },
    });
    return dataMapper;
  } finally {
    setLoading?.(false);
  }
};

export const deleteVoucherUseCase = async (
  deps: BaseCommonApiUseCaseDeps & { voucherId: number }
): Promise<boolean> => {
  const { voucherId, setLoading, showError, showSuccess } = deps;
  try {
    setLoading?.(true);
    let dataMapper = false;
    const res = await VoucherService.deleteVoucher(voucherId);
    HttpUtils.handleResponse(res, {
      onDefaultError() {
        showError?.(res?.message);
      },
      onSuccess() {
        showSuccess?.("Xóa voucher thành công");
        dataMapper = true;
      },
    });
    return dataMapper;
  } finally {
    setLoading?.(false);
  }
};

export const checkActiveVoucherUseCase = async (
  deps: BaseCommonApiUseCaseDeps & { code: string }
): Promise<VoucherResponse | undefined> => {
  const { code, setLoading, showError, showSuccess } = deps;
  try {
    setLoading?.(true);
    let dataMapper: VoucherResponse | undefined = undefined;
    const res = await VoucherService.checkActiveVoucher(code);
    HttpUtils.handleResponse(res, {
      onDefaultError() {
        showError?.("Mã voucher không hợp lệ");
      },
      onSuccess() {
        if (res.data) {
          showSuccess?.("Áp mã voucher thành công");
          dataMapper = res.data;
        } else {
          showError?.("Mã voucher không hợp lệ");
        }
      },
    });
    return dataMapper;
  } finally {
    setLoading?.(false);
  }
};
